export default function Footer() {
    return (
      <div className="footer">
        {/* <hr/> */}
        <a target="_blank" href="https://www.google.com/maps/dir//GREEN+FOREST+APARTMENTS,+300-320+Forest+Park+Dr,+Dayton,+OH+45405/@39.8093879,-84.2187984,15z/data=!4m17!1m7!3m6!1s0x884081b53ea880a5:0xcc7c52c501f344ab!2sGREEN+FOREST+APARTMENTS!8m2!3d39.8091463!4d-84.2185168!16s%2Fg%2F11gr426pfx!4m8!1m0!1m5!1m1!1s0x884081b53ea880a5:0xcc7c52c501f344ab!2m2!1d-84.2185168!2d39.8091463!3e3?entry=ttu"> <i className="fa fa-map-marker" aria-hidden="true"></i>&nbsp;300-320 Forest Park Dr, Dayton, OH 45405</a>
        <br/>
        <a className="social" href="https://www.facebook.com/GreenForestApts/" target="_blank"><i className="fa fa-facebook-square" aria-hidden="true"></i></a>
        &nbsp;  &nbsp;
        <a className="social" target="_blank" href="https://www.yelp.com/biz/green-forest-apartments-dayton"><i className="fa fa-yelp" aria-hidden="true"></i></a>
        <br/>
      <span className= "copy"> &copy;  Copyright 2024 Green Forest Apartments. </span>
      {/* &nbsp; &nbsp; &nbsp; */}
      {/* <span className="copy"> Designed and Developed by <a target="_blank" href="http://antonlys.com">me</a></span> */}

     
      </div>
    )
  }